import React from 'react';
import Button from '@mui/material/Button';
import TrialTagChips from '../record/TrialTagChips';
import { summarizeAllTags } from '../../util/trialTagFields';
import '../../../dist/assets/stylesheets/css/recordPatient.css';
import '../../../dist/assets/stylesheets/css/patients.css';

function TrialTagsBar(props) {
  const { sessionTags, trialTags, onEditTags } = props;
  const chips = summarizeAllTags(sessionTags, trialTags);

  return (
    <div className="review-trial-tags-bar">
      <TrialTagChips
        items={chips}
        className="review-trial-tags-bar__chips"
        emptyLabel="No tags yet"
      />
      <Button
        type="button"
        variant="outlined"
        size="small"
        className="review-trial-tags-bar__edit"
        onClick={onEditTags}
      >
        Edit Tags
      </Button>
    </div>
  );
}

export default TrialTagsBar;
